export default __webpack_public_path__ + "static/media/weeklyPrizeBingo.ea873430.png";